import React from 'react'

type AutoEndSessionProps = {
    startBotSession: (value: boolean) => void
}

const AutoEndSession = ({startBotSession}: AutoEndSessionProps) => {

    return (
        <div className="widget__overlay--endsession">
            <div className="warning-text">
                <div>Your chat session has ended.</div>  
            </div>
            <div className="action-buttons" style={{ justifyContent: 'center' }}>
                    <input type="button" value="Start again" className='form-button secondary' id="start-again-button" onClick={() => startBotSession(true)}/>
            </div>
        </div>
    )
}

export default AutoEndSession